import { CountryDto } from 'api';
import { useLocation } from 'react-router-dom';
import React from 'react';

export const getCountryNameByCode = (
  countries: CountryDto[],
  code?: string,
) => {
  return countries.find((country) => country.code === code)?.name;
};

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
